<template>
    <v-row no-gutters>
        <v-col cols="12">
            <v-row
                no-gutters
                class="mb-4"
            >
                <v-col class="title">
                    {{ $t('Import Clients') }}
                </v-col>
            </v-row>
            <v-row
                no-gutters
                align="center"
                class="mb-5"
            >
                <v-col class="body-2">
                    <div v-html="$t('Uku will import all clients, clients info and classificatiors. In the final step you can select which clients you want to add or update.')" /> <!-- INPUT FROM STATIC TRANSLATION -->
                </v-col>
            </v-row>

            <v-row
                no-gutters
                justify="end"
            >
                <v-col class="d-flex shrink">
                    <primary-button :loading="controller.model.isLoading()" @click="controller.handleStartImport()">
                        {{ $t("Start import") }}
                    </primary-button>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
import { $t } from "@/i18n";
import Controller from "../controller"

export default {
    name: "AppStoreDialogImportLogin",
    props: {
        controller: {
            type: Controller,
            required: true
        }
    }
};
</script>
